<template>
  <div>
    <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="userDialogVisible" :before-close="handleCloseDialog">
      <div class="mt20">
        <el-input placeholder="关键字" class="w300 seekIpt" v-model="searchInput" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
        <el-cascader class="ml20 w300" v-model="areaId" :options="areaList.options" @change="areaChange"
                     :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
      </div>
      <div style="margin-top: 10px;">
        <el-table :data="tableData" highlight-current-row @current-change="handleCurrentChange" border :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading">
          <el-table-column label="序号" width="80" type=index >
            <template slot-scope="scope">
              {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="entityName" label="主体名" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.entityName ? scope.row.entityName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="员工姓名" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.realName ? scope.row.realName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系方式" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.phone ? scope.row.phone: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="areaName" label="所属行政区" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.areaName ? scope.row.areaName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="subEntityName" label="子食堂名称" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.subEntityName ? scope.row.subEntityName: '-'}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px"></ybPagination>
      <div class="footer">
        <el-button @click="cancle" round>取消</el-button>
        <el-button type="primary" @click="bind" round>绑定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as proConnecApi from '@/api/prConnectprovincial'
import ybPagination from '@/components/ybPagination'
import * as subManageApi from "api/subManage";
export default {
  name: 'UserDialog',
  components: {
    ybPagination
  },
  data() {
    return {
      dialogTitle: '选择员工',
      dialogVisible: false,
      searchInput: '',
      parentId: '0',
      isTrueTree: true, // 是否成功返回区域树
      tableData: [],
      currentAreaCode: '',
      areaId: '',
      areaList: {
        selOptions: [],
        options: [],
        parentCode: '',
        props: {
          checkStrictly: true,
          expandTrigger: 'click',
          value: 'areaId',
          label: 'areaName',
          children: 'children',
          lazy: true,
          lazyLoad(node, resolve) {}
        }
      },
      tableLoading: false,
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      bindParams: {},
      selectedRow: {},
      areaData: []
    }
  },
  props: {
    userDialogVisible: {
      required: true,
      type: Boolean
    },
    //传过来了员工id
    userData: {
      type: Object,
      required: true
    }
  },
  computed: {
    queryListParams(){
      return {
        areaId: this.areaId,
        current: this.page.pageNum,
        keyword: this.searchInput,
        size: this.page.pageSize
      }
    }
  },
  methods: {
    search() {
      this.page.pageNum = 1;
      if(Array.isArray(this.areaId)) {
        this.areaId = this.areaId[this.areaId.length-1]
      }
      this.tableRefresh();
    },
    // 点击区域节点前的圆圈进行选择
    areaChange(val) {
      this.page.pageNum = 1;
      //防止清空选项时vue报错 传入的val应该是与之对应的areaId（数组），
      // 这里只是将areaId在事件中转化成一个String类型的值，传给后台
      if(val==null||val==undefined){
        this.areaId=''
        return;
      }
      this.areaId = val[val.length-1]
      this.tableRefresh();
    },
    // 列表行选中
    handleCurrentChange(row) {
      this.bindParams = {}
      if(!row) return
      this.bindParams.empid = this.userData.empid
      this.bindParams.employId = row.employId
      this.bindParams.realName = row.realName
      this.bindParams.phone = row.phone;
      this.bindParams.entityId = row.entityId;
      this.bindParams.entityName = row.entityName;
      this.bindParams.areaId = row.areaId;
      this.bindParams.subEntityId = row.subEntityId;
      this.bindParams.subEntityName = row.subEntityName
    },
    tableRefresh() {
      this.tableLoading = true
      proConnecApi.getEmployees(this.queryListParams).then(r => {
        if(r.code === 200) {
          this.tableData = r.data.records
          this.page.total = parseInt(r.data.total)
        }
        this.tableLoading = false;
      }).catch(err => {})
    },
    // 页数改变
    pageCurrentChange(num) {
      if(num !== this.page.pageNum) {
        this.page.pageNum = num;
        if(Array.isArray(this.areaId)) {
          this.areaId = this.areaId[this.areaId.length-1]
        }
        this.tableRefresh();
      }
    },
    // 页数据量改变
    pageSizeChange(size) {
      this.page.pageNum = 1
      if(size !== this.page.pageSize) {
        this.page.pageSize = size;
        if(Array.isArray(this.areaId)) {
          this.areaId = this.areaId[this.areaId.length-1]
        }
        this.tableRefresh();
      }
    },
    bind() {
      if(!this.bindParams || Object.keys(this.bindParams).length == 0) {
        this.$message.warning('请先点击列表,选择对应的员工后再绑定')
      } else {
        this.$confirm('确定要将该员工进行绑定吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          distinguishCancelAndClose: true
        }).then(() => {
          this.bindDinningRoom()
        }).catch(e => {
          // 关闭弹框
          if(e === 'close') return
          // 不同步
          this.$parent.diningRoomDialogVisible = false
        })
      }
    },
    bindDinningRoom() {
      proConnecApi.bindEmployees(this.bindParams).then(r=>{
        if(r.code === 200) {
          this.$message.success('绑定成功!')
          this.$parent.tableRefresh();
          this.handleCloseDialog();
        }
      }).catch(e=>{})
    },
    cancle() {
      this.handleCloseDialog();
    },
    handleCloseDialog() {
      this.$emit('closeUserDialog');
    },
    areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex) {
      if(!areaData.children) return
      areaData.children.forEach(item => {
        if(currentAreaId.slice(beginIndex, endIndex) === item.areaId.slice(beginIndex, endIndex)) {
          if(currentAreaId.length >= 8) { //街道
            if(endIndex >= 10) {
              return
            }  else {
              areaArr.push(item.areaId)
              areaData = item
              beginIndex += 2
              endIndex += 2
              this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
            }
          } else {
            if(currentAreaId.slice(2,6) == '0000'){ // 省或直辖市
              if(endIndex >= 4) {
                return
              }  else {
                areaArr.push(item.areaId)
                areaData = item
                beginIndex += 2
                endIndex += 2
                this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
              }
            } else if(currentAreaId.slice(2,4) !== '00' && currentAreaId.slice(4,6) == '00') { // 市
              if(endIndex >= 6) {
                return
              } else {
                areaArr.push(item.areaId)
                areaData = item
                beginIndex += 2
                endIndex += 2
                this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
              }
            } else { 
              if(endIndex >= 8) { // 区
                return
              } else {
                if(currentAreaId.slice(0,4) === '6590') {
                  // 新疆区域, 石河子市, 阿拉尔市, 图木舒克市, 五家渠市的区域编码规则与其他地区不同, 新僵地区区域编码特殊处理
                  endIndex += 4
                } else {
                  endIndex += 2
                }
                areaArr.push(item.areaId)
                areaData = item
                beginIndex += 2
                this.areaRecursion(currentAreaId, areaArr, areaData, beginIndex, endIndex)
              }
            }
          }
        }
      })
    },
    areaNameEcho() {
      let currentAreaId = this.areaId
      let areaArr = []
      this.areaRecursion(this.areaId, areaArr, this.areaData, 0, 2)

      // 直辖市下属区, 区域数组只有2个元素
      if(currentAreaId.slice(0,2) === '11' || currentAreaId.slice(0,2) === '12' || currentAreaId.slice(0,2) === '31' || currentAreaId.slice(0,2) === '50') {
        if(currentAreaId.slice(2,6) !== '0000' && currentAreaId.slice(2,6) !== '0101') { // 非省 且 非第一个区
          areaArr = [areaArr[0], areaArr[2]]
        }
      }
      this.areaId = areaArr
    },
  },
  created() {
    let that = this;
    that.areaList.props.lazyLoad = function (node, resolve) {
      let code = node.value ? node.value : that.parentId;
      if (code.length > 6) { 
        return resolve([]) 
      }
      subManageApi.tobAreaTree({parentId: code}).then(r => {
        if (r.code === 200) {
          that.areaData = r.data
          resolve(r.data.children)
        }
      });
    }
    this.areaId = this.userData.prAreaId;
    this.tableRefresh();
  },
  watch: {
    areaData: {
      handler(newVal) {
        this.areaNameEcho()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.dialogDiv {
  text-align: left;
}
.dialogDiv::v-deep .el-dialog{
  width: 1000px;
}
.footer {
  margin-top: 20px;
  text-align: right;
}
</style>